module.exports = __webpack_public_path__ + "static/img/aboutbg.8d25f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutbg.jpg
// module id = 1l5Y
// module chunks = 1